import axios from "axios";

export const adminGetAlertContents = async (query) => {
  const url =
    axios.getUri({ url: "/api/admin/alert-content", params: query }) ||
    `/api/admin/alert-content`;

  return axios(url, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const adminCreateAlertContent = async (data) => {
  const url = `/api/admin/alert-content`;
  return axios(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};

export const createAlertWithFile = async (formData) => {
  const url = `/api/admin/alert-content`;
  return axios.post(url, formData, {
    credentials: "include",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateAlertContentStatus = async (id, data) => {
  const url = `/api/admin/alert-content/${id}`;
  return axios(url, {
    method: "PATCH",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(data),
  });
};
